<template>
  <div class="vi-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ViButtonGroup'
  };
</script>


// WEBPACK FOOTER //
// packages/button-group/src/button-group.vue